import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SegmentsModule } from '@core/components/inputs/segments/segments.module';
import { StatusModule } from '@core/components/inputs/status/status.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { TabDeadlineComponent } from './tab-deadline.component';

@NgModule({
  entryComponents: [
    TabDeadlineComponent
  ],
  declarations: [
    TabDeadlineComponent
  ],
  imports: [
    TranslateModule,

    FuseSharedModule,

    MatIconModule,
    MatToolbarModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatTooltipModule,
    MatDatepickerModule,
    NgxMaskModule.forRoot(),

    SegmentsModule,
    StatusModule,
  ],
  exports: [
    TabDeadlineComponent
  ]
})
export class TabDeadlineModule {
}
